import React, { ReactNode } from 'react';

import TitleBar from './TitleBar/TitleBar';
import { IDataTestId } from '@custom';
import cn from 'utils/cn';

const sizingConstant = 95;
const height = `${sizingConstant}vh`;
const width = `${sizingConstant}vw`;

export type StudioModalProps = {
  children?: ReactNode;
  className?: string;
  customStyle?: any;
  modalName?: string;
  closeModal?: any;
  showBackBtn?: boolean;
  handleGoBack?: any;
  hideHelpBtn?: boolean;
  modalHeight?: string;
  modalWidth?: string;
  closeIconTestId?: string;
  sizing?: string;
  showWarning?: boolean;
  showError?: boolean;
  modalContainerProps?: any;
  hideCloseButton?: boolean;
  helpContent?: React.ReactNode | null;
} & IDataTestId;

export function StudioModal({
  children,
  className = '',
  customStyle = {},
  modalName,
  closeModal,
  showBackBtn = false,
  handleGoBack,
  hideHelpBtn = true,
  modalHeight = height,
  modalWidth = width,
  closeIconTestId = '',
  sizing = 'large',
  showWarning = false,
  showError = false, // If both Show Warning and Show Error are true, then precedence is given to Error
  modalContainerProps = {},
  hideCloseButton = false,
  helpContent = null,
}: StudioModalProps) {
  return (
    <div
      className="modal-background studio-modal tw:flex tw:items-center tw:justify-center tw:w-full"
      style={{
        zIndex: 1500,
        ...customStyle,
      }}
    >
      <div
        {...modalContainerProps}
        className={cn(
          'tw:border-0 tw:rounded-xs picklewood-blue tw:opacity-100 tw:flex-col tw:flex tw:bg-primary-100',
          className,
          modalContainerProps?.className
        )}
        style={{
          height: modalHeight,
          // TODO: define sizing min & max widths w/designer
          width: sizing === 'small' ? 'var(--sizing720)' : modalWidth,
        }}
      >
        <TitleBar
          {...{
            modalName,
            closeModal,
            showBackBtn,
            handleGoBack,
            hideHelpBtn,
            closeIconTestId,
            showWarning,
            showError,
            hideCloseButton,
            helpContent,
          }}
        />
        {children}
      </div>
    </div>
  );
}

export default StudioModal;
